const config = {
    bykushURL: String(process.env.REACT_APP_BYKUSH_BASE_URL),
}

export default config;